import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Select, Typography, Flex, Input, Checkbox, InputNumber } from 'antd';

import { conditionalFields } from './const';

const { Text } = Typography;
const conditionalOutcome = conditionalFields['CITATIONS'];

export const TableCol = (handleSave) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { research_point_data: researchPointData, outcome_type: outComeType } = staticData;

  const [dynamicRows, setDynamicRows] = useState({});

  const handleCheckboxChange = (rowKey, isChecked) => {
    // Ensure the row is initialized in dynamicRows if it doesn't exist
    const existingRow = dynamicRows[rowKey] || {};

    const updatedRow = {
      ...existingRow,
      has_multiple_iub_authors: isChecked,
      point_split_percentage: isChecked ? existingRow.point_split_percentage || 0 : 0, // Set to zero if unchecked
    };

    setDynamicRows((prev) => ({
      ...prev,
      [rowKey]: updatedRow,
    }));
    handleSave(updatedRow);
  };

  const getDynamicRow = (row) => dynamicRows[row?.key] || row || {};


  return [
    {
      key: 'outcome',
      dataIndex: 'outcome',
      title: 'Outcome',
      render: (value, row) => {
        const _researchPointData = researchPointData.filter(
          (item) => item.id === value
        );
        const _researchPoint = _researchPointData[0];

        return (
          <Select
            style={{ width: '300px', minHeight: '88px' }}
            options={[
              ...researchPointData.map((item) => ({
                value: item.id,
                outcomeId: item.outcome_type,
                label: (
                  <Flex vertical>
                    <Text>
                      {
                        outComeType.find(
                          (outcome) => outcome.value === item.outcome_type
                        ).label
                      }
                    </Text>
                    <Text>{item.publishing_venue}</Text>
                    <Text type="secondary">({item.point} APA Points)</Text>
                  </Flex>
                )
              }))
            ]}
            defaultValue={_researchPoint.id}
            placeholder="Select a Event"
            onChange={(e) => {
              const updatedRow =
                e === conditionalOutcome
                  ? {
                    ...row,
                    is_lead_author: false,
                    title_or_description: '',
                    point_split_percentage: 0,
                    has_multiple_iub_authors: false,
                    citation: 0,
                    outcome: e
                  }
                  : { ...row, outcome: e };
              handleSave(updatedRow);
            }}
          />
        );
      }
    },
    {
      key: 'title_or_description',
      dataIndex: 'title_or_description',
      title: 'Working Title / Brief Description',
      render: (value, row) =>
        row?.outcome === conditionalOutcome ? (
          ''
        ) : (
          <Input
            placeholder="Enter"
            value={value}
            onChange={(e) =>
              handleSave({ ...row, title_or_description: e.target.value })
            }
          />
        )
    },
    {
      key: 'is_lead_author',
      dataIndex: 'is_lead_author',
      title: 'Single Author',
      render: (value, row) =>
        row.outcome === conditionalOutcome || row.has_multiple_iub_authors ? (
          ''
        ) : (
          <Checkbox
            placeholder="Enter"
            defaultChecked={value}
            onChange={(e) =>
              handleSave({
                ...row,
                is_lead_author: e.target.checked,
                is_principal_author: false,
                has_external_authors: false,
                has_multiple_iub_authors: false,
                point_split_percentage: e.target.checked ? row?.point_split_percentage : 0,
              })
            }
          />
        )
    },
    {
      key: 'is_principal_author',
      dataIndex: 'is_principal_author',
      title: 'Principal Author',
      render: (value, row) =>
        row?.outcome === conditionalOutcome ? '' :
          row?.is_lead_author || row?.has_multiple_iub_authors ? '' : (
            <Checkbox
              placeholder="Enter"
              defaultChecked={value}
              onChange={(e) =>
                handleSave({ ...row, is_principal_author: e.target.checked })
              }
            />
          )
    },
    {
      key: 'has_external_authors',
      dataIndex: 'has_external_authors',
      title: 'External Authors',
      render: (value, row) =>
        row?.is_lead_author || row?.has_multiple_iub_authors ? '' : (
          <Checkbox
            placeholder="Enter"
            defaultChecked={value}
            checked={value}
            onChange={(e) => {
              handleSave({
                ...row,
                has_external_authors: e.target.checked,
              });
            }}
          />
        )
    },
    {
      key: 'has_multiple_iub_authors',
      dataIndex: 'has_multiple_iub_authors',
      title: 'Multiple IUB Authors',
      render: (value, row) => {
        const dynamicRow = getDynamicRow(row);

        return (
          dynamicRow?.outcome === conditionalOutcome ? ''
            : row?.is_lead_author ? '' : (
              <Checkbox
                placeholder="Enter"
                // defaultChecked={value}
                checked={value}
                onChange={(e) => {
                  handleCheckboxChange(dynamicRow, e.target.checked);
                  // handleSave({ ...dynamicRow, has_multiple_iub_authors: e.target.checked })
                  handleSave({
                    ...dynamicRow,
                    has_multiple_iub_authors: e.target.checked,
                    point_split_percentage: e.target.checked ? dynamicRow.point_split_percentage : 0, // Explicitly update the point split percentage when unchecked

                    // reset contribution when unchecked
                    is_lead_author: false,
                    is_principal_author: false,
                    has_external_authors: false
                  });
                }}
              />
            )
        )
      }
    },
    {
      key: 'point_split_percentage',
      dataIndex: 'point_split_percentage',
      title: 'Contribution Percentage',
      render: (value, row) => {
        const dynamicRow = getDynamicRow(row);

        return dynamicRow?.outcome === conditionalOutcome || !row?.has_multiple_iub_authors ? ''
          : (
            <InputNumber
              placeholder="Enter"
              value={dynamicRow?.point_split_percentage}
              disabled={!dynamicRow?.has_multiple_iub_authors}
              min={0} // Minimum value set to 0
              onChange={(e) =>
                handleSave({ ...dynamicRow, point_split_percentage: e })
              }
            />
          )
      }
    },
    {
      key: 'citation',
      dataIndex: 'citation',
      title: 'No of Citation',
      render: (value, row) =>
        row.outcome !== conditionalOutcome ? (
          ''
        ) : (
          <Input
            placeholder="Enter"
            value={value}
            onChange={(e) => handleSave({ ...row, citation: e.target.value })}
          />
        )
    }
  ];
};
